var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-col",
    {
      attrs: {
        cols: "12"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" Shared With Me ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-data-table",
                {
                  attrs: {
                    headers: _vm.headersMyAccounts,
                    items: _vm.myAccessList,
                    "show-expand": "",
                    expanded: _vm.expandedMy,
                    "item-key": "id",
                    "single-expand": "",
                    loading: !_vm.loaded
                  },
                  on: {
                    "update:expanded": function updateExpanded($event) {
                      _vm.expandedMy = $event
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "expanded-item",
                      fn: function fn(_ref) {
                        var headers = _ref.headers,
                          item = _ref.item
                        return [
                          _c(
                            "td",
                            {
                              attrs: {
                                colspan: headers.length
                              }
                            },
                            [
                              _c("v-data-iterator", {
                                attrs: {
                                  items: item.services,
                                  "hide-default-footer": ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function fn(props) {
                                        return [
                                          _c(
                                            "v-row",
                                            _vm._l(props.items, function(
                                              item,
                                              index
                                            ) {
                                              return _c(
                                                "v-col",
                                                {
                                                  key: index,
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                    md: "3"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-card",
                                                    [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          attrs: {
                                                            dense: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _vm._v(
                                                                    " Service ID: "
                                                                  ),
                                                                  _c(
                                                                    "router-link",
                                                                    {
                                                                      attrs: {
                                                                        to: _vm.link(
                                                                          item.id
                                                                        )
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.id
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item",
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _vm._v(
                                                                    " Name: "
                                                                  ),
                                                                  _c(
                                                                    "router-link",
                                                                    {
                                                                      attrs: {
                                                                        to: _vm.link(
                                                                          item.id
                                                                        )
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.product
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item",
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _vm._v(
                                                                    " Domain: "
                                                                  ),
                                                                  _c(
                                                                    "router-link",
                                                                    {
                                                                      attrs: {
                                                                        to: _vm.link(
                                                                          item.id
                                                                        )
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.domain
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item",
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "gg-btn",
                                                                    {
                                                                      attrs: {
                                                                        text: ""
                                                                      },
                                                                      on: {
                                                                        click: function click(
                                                                          $event
                                                                        ) {
                                                                          return _vm.openSharedDeleteModal(
                                                                            item
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Delete Access "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "visually-hidden text-lowercase"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "button"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("v-progress-linear", {
                    attrs: {
                      slot: "progress",
                      color: "green",
                      height: "2",
                      indeterminate: ""
                    },
                    slot: "progress"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("delete-shared-modal", {
        attrs: {
          opened: _vm.sharedDeleteModal,
          service: _vm.sharedServiceToDelete
        },
        on: {
          close: _vm.closeSharedDeleteModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }